import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import PhoneBind from './pages/PhoneBind';
import SuccessBind from './pages/SuccessBind';
import MainLayout from './components/MainLayout';
import { userStorage } from './utils/storage';
import './App.css';

// 路由守卫组件
function PrivateRoute({ children }) {
  // 检查用户信息是否存在（使用 storage.js 会自动检查过期时间）
  const userInfo = userStorage.getUserInfo();
  const isLoggedIn = userInfo && userStorage.isLoggedIn();
  return isLoggedIn ? children : <Navigate to="/login" />;
}

// 备案信息组件
function BeianFooter() {
  return (
    <footer className="beian-footer">
      <a 
        href="https://beian.mps.gov.cn/#/query/webSearch?code=33011002018523" 
        rel="noreferrer" 
        target="_blank"
        className="beian-link"
      >
        <img src="/beian-icon.png" alt="备案图标" className="beian-icon" />
        浙公网安备33011002018523号
      </a>
    </footer>
  );
}

function App() {
  return (
    <div className="app-container">
      <div className="app-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/phone-bind" element={<PhoneBind />} />
          <Route path="/success-bind" element={<SuccessBind />} />
          
          {/* 所有 /main 路由都使用 MainLayout */}
          <Route
            path="/main/*"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          />
          
          {/* 默认路由 */}
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
      <BeianFooter />
    </div>
  );
}

export default App;
